import { useRef, useState } from "react";
import { ICategory, IMenuItemResponce } from "../Interfaces/responseTypes";

const useDragnDropHooks = (order_list: number[], onDragHandler: (updatedOrder: number[]) => void) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isDraggable, setIsDraggable] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);
  const handleIconMouseDown = () => {
    setIsDraggable(true);
  };

  const handleIconMouseUp = () => {
    setIsDraggable(false);
  };
  const dragOverHandler = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const dragStartHandler = (e: React.DragEvent<HTMLDivElement>, draggedData: ICategory | IMenuItemResponce) => {
    if (!isDraggable) {
      e.preventDefault();
      return;
    }
    setIsDragging(true);
    if (cardRef.current) {
      e.dataTransfer.setDragImage(cardRef.current, 50, 50);
    }
    e.dataTransfer.setData('text/plain', String(draggedData.id));
  };

  const dragEndHandler = () => {
    setIsDragging(false);
    setIsDraggable(false);
  };

  const dropHandler = (e: React.DragEvent<HTMLDivElement>, dropId: number) => {
    e.preventDefault();
    const draggedId = parseInt(e.dataTransfer.getData('text/plain'), 10);

    if (!isNaN(draggedId)) {
      const newOrderList = order_list!.map((order) => {
        if (order === dropId) {
          return draggedId;
        } else if (order === draggedId) {
          return dropId;
        } else {
          return order;
        }
      });
      onDragHandler!(newOrderList);
    }
  };

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    if (isDragging) {
      const threshold = 50;
      const scrollSpeed = 20;

      if (e.clientY < threshold) {
        window.scrollBy({ top: -scrollSpeed, behavior: 'smooth' });
      } else if (window.innerHeight - e.clientY < threshold) {
        window.scrollBy({ top: scrollSpeed, behavior: 'smooth' });
      }
    }
  };

  return {
    cardRef,
    isDragging,
    isDraggable,
    handleDrag,
    dropHandler,
    dragEndHandler,
    dragOverHandler,
    dragStartHandler,
    handleIconMouseUp,
    handleIconMouseDown,
  }
};

export default useDragnDropHooks